import dividendAnalysisService from '../../../core/services/Fundamental/DividendAnalysisService';
import reducerRegistry from '../../helpers/ReducerRegistry';
import Const from './Const';
import {
  getDataFollowKeyByDot,
  getSyncDefaultSearch,
} from './../../helpers/Common';
import { keyBy } from 'lodash';
import moment from 'moment';
import { formatPercent } from '../../helpers/Text';
import snapShotService from './../../../core/services/Fundamental/SnapShotService';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'FUNDAMENTAL:FA_DIVIDEND_ANALYSIS:';
const FETCH_ANALYSIS = `${REDUCER_NAME}FETCH_ANALYSIS`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_COMPANY_SCORE = `${REDUCER_NAME}FETCH_COMPANY_SCORE`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_LAST_PRICE_DATA = `${REDUCER_NAME}FETCH_LAST_PRICE_DATA`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const YEAR_TTM = 'TTM';

export {
  REDUCER_NAME,
  reducer as default,
  fetchAnalysis,
  changeCode,
  fetchCompanyScore,
  subscribeRealtimeTick,
  fetchLastPrice,
};

function changeCode(currentSearch, componentId) {
  console.log(34534535345);
  return dispatch => {
    const { code } = currentSearch;
    dispatch({
      type: CHANGE_CODE,
      payload: {
        componentId,
        currentSearch,
      },
    });
    dispatch(fetchLastPrice(code, componentId));
    dispatch(fetchAnalysis(code, componentId));
    dispatch(fetchCompanyScore(code, componentId));
  };
}

function fetchAnalysis(code, id) {
  const params = {
    OrganCode: code,
    Code: code,
  };

  return dispatch => {
    dividendAnalysisService.GetAnalysis(params).then(response => {
      const { items: listAnalysis = [] } = response ? response : [];

      dispatch({
        type: FETCH_ANALYSIS,
        payload: {
          listAnalysis,
          dataId: id,
        },
      });
    });
  };
}

function fetchLastPrice(code, id) {
  const params = {
    OrganCode: code,
    Code: code,
  };
  return dispatch => {
    dividendAnalysisService.getLastPriceData(params).then(response => {
      const { items = [] } = response ? response : [];
      const indexData = items ? items[0].priceInfo : {};
      dispatch({
        type: FETCH_LAST_PRICE_DATA,
        payload: {
          indexData,
          componentId: id,
        },
      });
    });
  };
}

function fetchCompanyScore(organCode, componentId) {
  return dispatch => {
    snapShotService.getCompanyScore({ OrganCode: organCode }).then(res => {
      const { items = [] } = res ? res : [];
      const data = items && items[0] ? items[0] : {};

      dispatch({
        type: FETCH_COMPANY_SCORE,
        payload: {
          componentId,
          data,
        },
      });
    });
  };
}

function subscribeRealtimeTick(data, componentId) {
  return {
    type: SUBSCRIBE_REALTIME_DATA_TICK,
    payload: {
      data,
      componentId,
    },
  };
}

// function formatXasisYearChart(data) {
//   let formatData = data;
//   formatData.forEach(item => {
//     if (item.yearReport === new Date().getFullYear() - 1) {
//       item.yearReport = YEAR_TTM;
//     }
//   });
//   return formatData;
// }

// ================================================== REDUCE ===========================================================
const initialState = {
  listMultiComponent: {},
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const { id: dataId, dragCode } = action.payload;
      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            score: {},
            condition: {
              currentSearch: dragCode ||
                currentState.get(
                  ConstCommon.listComponent.FADividendAnalysis,
                  'currentSearch',
                  dataId,
                ) ||
                getSyncDefaultSearch(
                  ConstCommon.listComponent.FADividendAnalysis,
                  true,
                ) || {
                  code: Const.codeDefault,
                  displayCode: Const.displayDefault,
                },
            },
            dataChartPE: [],
            dataChartDE: [],
            listDataDividendTable: [],
            dataDividendTableByYear: {},
          },
        },
      };

    case UNMOUNT_COMPONENT: {
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };
    }

    case FETCH_ANALYSIS: {
      const { listAnalysis, dataId } = action.payload;

      const dataObj = listAnalysis ? listAnalysis[0] : {};

      const dividendYield = dataObj.dividendYield
        ? dataObj.dividendYield.ratioYears
        : [];
      const dividendYieldByYear = keyBy(dividendYield, Const.yearReport);

      const priceEarningRatio = dataObj.priceEarningRatio
        ? dataObj.priceEarningRatio.ratioYears
        : [];
      let dataChartPE = priceEarningRatio
        .map(item => ({
          ...item,
          ratioValueYield:
            dividendYieldByYear[item.yearReport].ratioValue * 100,
        }))
        .sort((a, b) => a.yearReport - b.yearReport)
        .slice(7, priceEarningRatio.length);
      dataChartPE.push({
        yearReport: YEAR_TTM,
        ratioValue: dataObj.priceEarningRatio.ratioTTM,
        ratioValueYield: dataObj.dividendYield.ratioTTM * 100,
      });

      //data chart DE
      const dividendPayoutRatio = dataObj.dividendPayoutRatio
        ? dataObj.dividendPayoutRatio.ratioYears
        : [];
      const dividendYieldPayoutByYear = keyBy(
        dividendPayoutRatio,
        Const.yearReport,
      );

      const dps = dataObj.dps ? dataObj.dps.ratioYears : [];
      const dpsByYear = keyBy(dps, Const.yearReport);

      const eps = dataObj.eps ? dataObj.eps.ratioYears : [];
      let dataChartDE = eps
        .map(item => ({
          ...item,
          dividendPayoutValue:
            dividendYieldPayoutByYear[item.yearReport].ratioValue * 100,
          dpsValue: dpsByYear[item.yearReport].ratioValue,
        }))
        .sort((a, b) => a.yearReport - b.yearReport)
        .slice(7, eps.length);
      dataChartDE.push({
        yearReport: YEAR_TTM,
        dividendPayoutValue: dataObj.dividendPayoutRatio.ratioTTM * 100,
        dpsValue: dataObj.dps.ratioTTM,
        ratioValue: dataObj.eps.ratioTTM,
      });

      //data table
      const cashDividendPayouts = dataObj.cashDividendPayouts || [];
      const cashDividendPlans = dataObj.cashDividendPlans || [];
      const currentYear = moment().year();
      const currentMonth = moment().month() + 1;

      if (cashDividendPayouts.length > 0) {
        const checkCurrentYear = cashDividendPayouts.find(
          item => item.exrightYear === currentYear,
        );
        if (!checkCurrentYear) {
          cashDividendPayouts.push({
            exrightMonth: '',
            exrightYear: currentYear,
            valuePerShare: '',
          });
        }
      }

      const formatCashDividendPayouts = cashDividendPayouts => {
        const payouts = {};
        const monthCount = [];
        cashDividendPayouts.forEach(item => {
          const exRightYear = {
            total:
              (payouts[item.exrightYear] && payouts[item.exrightYear].total
                ? payouts[item.exrightYear].total
                : 0) + +item.valuePerShare,
            yield: !dividendYieldByYear[item.exrightYear]
              ? ''
              : formatPercent(dividendYieldByYear[item.exrightYear].ratioValue),
            year: item.exrightYear,
          };
          if (item.exrightMonth) {
            const monthValues = cashDividendPayouts.filter(
              it =>
                it.exrightYear === item.exrightYear &&
                it.exrightMonth === item.exrightMonth,
            );
            const total = monthValues.reduce((result, { valuePerShare }) => {
              return result + valuePerShare;
            }, 0);
            payouts[item.exrightYear] = {
              ...payouts[item.exrightYear],
              ...exRightYear,
              [item.exrightMonth]: {
                total,
                items: monthValues,
              },
            };
          } else {
            payouts[item.exrightYear] = {
              ...exRightYear,
            };
          }
          // check position red color of month in current year
          const monthIndex = monthCount.findIndex(
            it => it.month === item.exrightMonth,
          );
          if (monthIndex !== -1) {
            monthCount[monthIndex].count += 1;
          } else {
            monthCount.push({
              month: item.exrightMonth,
              count: 1,
            });
          }
        });

        return {
          payouts,
          monthCount,
        };
      };

      const getCurrentYear = () => new Date().getFullYear();

      const getNearestMonth = (monthCount, cashDividendPlan, payouts) => {
        const sortedMonthCount = monthCount.sort((a, b) => b.count - a.count);
        const [max] = sortedMonthCount;
        const maxs = monthCount.filter(it => it.count === max.count);
        let chooseMonth = 0;
        if (maxs.length === 1) {
          let x = max.month > currentMonth ? max.month : currentMonth + 1;
          for (let m = x; m <= 12; m++) {
            if (!payouts[currentYear][m]) {
              chooseMonth = m;
              break;
            }
          }
          return {
            month: chooseMonth,
            value: cashDividendPlan.valuePerShare - payouts[currentYear].total,
          };
        }

        let nearestIndex = 0;
        for (let j = 0; j < maxs.length; j++) {
          if (
            maxs[nearestIndex].month &&
            maxs[nearestIndex].month - currentMonth >
              maxs[j].month - currentMonth
          ) {
            nearestIndex = j;
            continue;
          }
        }

        let t =
          maxs[nearestIndex].month > currentMonth
            ? maxs[nearestIndex].month
            : currentMonth + 1;
        for (let k = t; k <= 12; k++) {
          if (!payouts[currentYear][k]) {
            chooseMonth = k;
            break;
          }
        }

        return {
          month: chooseMonth,
          value: cashDividendPlan.valuePerShare - payouts[currentYear].total,
        };
      };

      const getRedMonth = (cashDividendPayouts, cashDividendPlans) => {
        const currentYear = getCurrentYear();
        const { payouts, monthCount } = formatCashDividendPayouts(
          cashDividendPayouts,
        );
        const cashDividendPlan = cashDividendPlans.find(
          item => item.dividendYear === currentYear,
        );
        if (!cashDividendPlan) {
          return null;
        }

        if (Object.keys(payouts).length === 0) {
          return null;
        }

        if (cashDividendPlan.valuePerShare <= payouts[currentYear].total) {
          return null;
        }

        return getNearestMonth(monthCount, cashDividendPlan, payouts);
      };

      let dataDividendTableByYear = {};

      const listDataDividendTable = cashDividendPayouts
        .map(item => getDataFollowKeyByDot(item, Const.exrightYear))
        .filter((elem, pos, arr) => {
          return arr.indexOf(elem) === pos;
        })
        .sort((a, b) => b - a);

      const { payouts } = formatCashDividendPayouts(cashDividendPayouts);
      if (getRedMonth(cashDividendPayouts, cashDividendPlans) !== null) {
        const redMonth = getRedMonth(cashDividendPayouts, cashDividendPlans);
        dataDividendTableByYear = Object.keys(payouts).reduce(
          (result, item) => {
            if (!item) {
              return result;
            }
            if (+item === currentYear) {
              return {
                ...result,
                [item]: {
                  ...payouts[item],
                  [redMonth.month]: {
                    value: redMonth.value,
                    isRed: true,
                  },
                  total:
                    payouts[item].total === 0
                      ? redMonth.value
                      : payouts[item].total + redMonth.value,
                },
              };
            }

            return {
              ...result,
              [item]: payouts[item],
            };
          },
          {},
        );
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [dataId]: {
            ...state.listMultiComponent[dataId],
            analysisData: listAnalysis,
            dataChartPE,
            dataChartDE,
            listDataDividendTable,
            dataDividendTableByYear:
              Object.keys(dataDividendTableByYear).length > 0
                ? dataDividendTableByYear
                : payouts,
          },
        },
      };
    }

    case CHANGE_SIZE_COMPONENT:
      const { id } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [id]: {
            ...state.listMultiComponent[id],
            component: action.payload,
          },
        },
      };

    case FETCH_COMPANY_SCORE: {
      const { componentId, data } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            score: data,
          },
        },
      };
    }

    case CHANGE_CODE: {
      const { componentId, currentSearch } = action.payload;

      const { code, displayCode } = currentSearch;

      currentState.add(
        ConstCommon.listComponent.FADividendAnalysis,
        'currentSearch',
        { code, displayCode },
        componentId,
      );

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            condition: {
              ...state.listMultiComponent[componentId].condition,
              currentSearch,
            },
          },
        },
      };
    }

    case FETCH_LAST_PRICE_DATA: {
      const { indexData, componentId } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            condition: {
              ...state.listMultiComponent[componentId].condition,
              indexData,
            },
          },
        },
      };
    }

    case SUBSCRIBE_REALTIME_DATA_TICK: {
      const { data, componentId } = action.payload;
      const dataRealtime = data.find(
        item => item.organCode === state.listMultiComponent[componentId].code,
      );
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            condition: {
              ...state.listMultiComponent[componentId].condition,
              dataRealtime,
            },
          },
        },
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
